import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import SaveIcon from '@mui/icons-material/Save';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';

export function CreateJointFragmentBtn() {
  const { openDrawer } = usePageDrawer();
  const fragment = useFragmentEditorStore((state) => state.fragment);

  const handleSave = () => {
    if (!fragment) return;

    openDrawer('create-joint-fragment');
  };

  return (
    <Button
      data-testid="joint-fragment-save"
      variant="outlined"
      startIcon={<SaveIcon />}
      onClick={handleSave}
    >
      <FormattedMessage
        id="jointFragments.editorScreen.toolbar.create"
        defaultMessage="Crear fragmento"
      />
    </Button>
  );
}
